import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountLogout',
  setup(__props) {

const localizer = Localizer;
const routes = (window as any).App.routes;

async function logout() {
    localStorage.removeItem("token");

    await Axios.post(routes.Account_Logout, null);

    window.location.href = routes.Home_Home;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (logout())),
    class: "link cur-p"
  }, _toDisplayString(_unref(localizer).get("Account.Common.Logout")), 1))
}
}

})